var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card card-login"},[_c('div',{class:'card-header card-header-'+_vm.headerColor+' text-'+_vm.align},[_c('h4',{staticClass:"card-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_vm._v(" "),_c('div',{staticClass:"card-body pb-3"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }